import Head from 'next/head';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useQuery } from '@apollo/client';
import { CoursesIntro } from 'plaza-react-components/src/components/redesign';

import Preloader from '../../shared/preloader';
import coursesQuery from '../../requests/queries/courses';

export default function Page({
  config,
  user,
  userSubscriptions,
  addUserEvent
}) {
  const router = useRouter();
  const { data, loading } = useQuery(coursesQuery);

  useEffect(() => {
    addUserEvent({
      variables: { type: 'courses-landingspage', data: '{}' }
    });

    if (user.hasCourseAccess) router.push('/zwangerschapscursus/ouder-en-kind');
  }, [user.hasCourseAccess]);

  if (loading) return <Preloader />;

  return (
    <>
      <Head>
        <title>Zwangerschapscursus</title>
      </Head>

      <CoursesIntro
        user={user}
        config={config}
        addUserEvent={addUserEvent}
        userSubscriptions={userSubscriptions}
        list={data?.courses.filter(({ isGroup }) => isGroup)}
      />
    </>
  );
}
